//引入Vue
import Vue from 'vue'
//引入VueRouter
import VueRouter from 'vue-router'
import routes from './routes.js'
//声明使用VueRouter
Vue.use(VueRouter)
export default new VueRouter({
    // mode: 'hash', //让路由地址中不出现"#"
    mode: 'history', //让路由地址中不出现"#"
    routes
})